import dotenv from 'dotenv'
dotenv.config()

const env = {
	production: {
		API: 'https://shinbundobutsuen.com/breed/wp-json/urb/zoo/',
	},
	development: {
		API: 'https://zoo.hoodschool.net/breed/wp-json/urb/zoo/',
	}
}

const config = {
	API: env[process.env.REACT_APP_URB_ZOO_ENV].API,
	iOSErrorUrl: 'https://shinbundobutsuen.com/ohanashikoen/vr/ios-permission.html',
	camera: {
		position: [0, 0, 4],
		walkSpeed: 0.55,
		virticalMin: 7, // 正面から上向きの角度
		virticalMax: 25, // 正面から下向きの角度
		lookSpeed: 0.04, // マウス操作時に上を向く速度
	},
	color: {
		sky: '#d4feff',
		ground: '#7be61e',
	},
	stage: {
		model: './chiba-museum.fbx',
		scale: [0.001, 0.001, 0.001], // mm → m
		xMin: -6.2,
		xMax: 0.1,
		y: 0.7,
		zMin: -3,
		zMax: 4,
	},
	collision: {
		ignoreList: [
			'柱状体_A_モデリング_ダンボール_2', // 壁 2〜10, 16〜24
			'柱状体_A_モデリング_ダンボール_3',
			'柱状体_A_モデリング_ダンボール_4',
			'柱状体_A_モデリング_ダンボール_5',
			'柱状体_A_モデリング_ダンボール_6',
			'柱状体_A_モデリング_ダンボール_7',
			'柱状体_A_モデリング_ダンボール_8',
			'柱状体_A_モデリング_ダンボール_9',
			'柱状体_A_モデリング_ダンボール_10',
			'柱状体_A_モデリング_ダンボール_16',
			'柱状体_A_モデリング_ダンボール_17',
			'柱状体_A_モデリング_ダンボール_18',
			'柱状体_A_モデリング_ダンボール_19',
			'柱状体_A_モデリング_ダンボール_20',
			'柱状体_A_モデリング_ダンボール_21',
			'柱状体_A_モデリング_ダンボール_22',
			'柱状体_A_モデリング_ダンボール_23',
			'柱状体_A_モデリング_ダンボール_24',
			'柱状体_A_モデリング_ダンボール_11', // 山 11
		],
		distance: 0.5,
		viewVolume: [
			{ x: 0.0, y: 0.0 },
			{ x: 0.2, y: 0.2 },
			{ x: 0.2, y: -0.2 },
			{ x: -0.2, y: 0.2 },
			{ x: -0.2, y: -0.2 }
		],
		isTarget: (name) => {
			if (name.indexOf('ダンボール') === -1) {
				return false
			}

			if (config.collision.ignoreList.includes(name)) {
				return false
			}

			return true
		}
	}
}

export default config